/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_TitleInputs */

const en_speaker_manager_title = /** @type {(inputs: Speaker_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speaker Manager`)
};

const fr_speaker_manager_title = /** @type {(inputs: Speaker_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionnaire des locuteurs`)
};

const de_speaker_manager_title = /** @type {(inputs: Speaker_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprechermanager`)
};

const it_speaker_manager_title = /** @type {(inputs: Speaker_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabile degli altoparlanti`)
};

const ru_speaker_manager_title = /** @type {(inputs: Speaker_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер спикеров`)
};

const es_speaker_manager_title = /** @type {(inputs: Speaker_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de oradores`)
};

const zh_cn2_speaker_manager_title = /** @type {(inputs: Speaker_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`演讲者经理`)
};

const ja_speaker_manager_title = /** @type {(inputs: Speaker_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーマネージャー`)
};

const hi_speaker_manager_title = /** @type {(inputs: Speaker_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ता प्रबंधक`)
};

const pt_pt2_speaker_manager_title = /** @type {(inputs: Speaker_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de palestrantes`)
};

/**
* | output |
* | --- |
* | "Speaker Manager" |
*
* @param {Speaker_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_title = /** @type {((inputs?: Speaker_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speaker_manager_title(inputs)
	if (locale === "de") return de_speaker_manager_title(inputs)
	if (locale === "it") return it_speaker_manager_title(inputs)
	if (locale === "ru") return ru_speaker_manager_title(inputs)
	if (locale === "es") return es_speaker_manager_title(inputs)
	if (locale === "zh-CN") return zh_cn2_speaker_manager_title(inputs)
	if (locale === "ja") return ja_speaker_manager_title(inputs)
	if (locale === "hi") return hi_speaker_manager_title(inputs)
	if (locale === "pt-PT") return pt_pt2_speaker_manager_title(inputs)
	return en_speaker_manager_title(inputs)
});